exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr[data-v-271c3b9b]{color:#444;cursor:pointer}tr.is-new[data-v-271c3b9b]{background-color:#f1f8ff}.main-td-content[data-v-271c3b9b]{width:100%}.sub-td-content[data-v-271c3b9b]{width:1%;white-space:nowrap}.inbox-widget-heading[data-v-271c3b9b]{font-size:1em}.is-new .inbox-widget-heading[data-v-271c3b9b]{font-weight:700}.inbox-widget-sub-heading[data-v-271c3b9b]{font-size:.8em;color:#444}.is-new .inbox-widget-sub-heading[data-v-271c3b9b]{font-weight:700}.read-icon[data-v-271c3b9b]{color:#dc3545}.date-icon[data-v-271c3b9b],.read-icon.is-read[data-v-271c3b9b]{color:#007bff}td[data-v-271c3b9b]{vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-271c3b9b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/received-files-view/received-files-entry.vue
// module id = 81
// module chunks = 0